import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "mc-radiogroup-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.complete || !_ctx.useAlert)
      ? (_openBlock(), _createBlock(_component_v_radio_group, {
          key: 0,
          class: "mc-radiogroup",
          modelValue: _ctx.column,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.column) = $event)),
          inline: _ctx.row,
          column: !_ctx.row,
          "hide-details": "",
          readonly: _ctx.complete && _ctx.stopOnComplete
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.radioOptions.entries(), ([index, option]) => {
              return (_openBlock(), _createBlock(_component_v_radio, {
                key: index,
                color: `${_ctx.color(index)}`,
                value: index,
                label: option,
                onChange: ($event: any) => (_ctx.selectChoice(index)),
                "true-icon": `${_ctx.icon(index)}`,
                class: _normalizeClass([_ctx.hideInput ? 'hidden' : ''])
              }, {
                label: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default", {
                    index: index,
                    text: option,
                    feedback: _ctx.feedbacks[index],
                    selected: index==_ctx.column,
                    color: _ctx.color(index),
                    column: _ctx.column
                  }, () => [
                    _createTextVNode(_toDisplayString(option), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["color", "value", "label", "onChange", "true-icon", "class"]))
            }), 128))
          ]),
          _: 3
        }, 8, ["modelValue", "inline", "column", "readonly"]))
      : _createCommentVNode("", true),
    (_ctx.complete && _ctx.useAlert)
      ? _withDirectives((_openBlock(), _createBlock(_component_v_alert, {
          key: 1,
          variant: "tonal",
          color: `${_ctx.color(_ctx.column)}`,
          icon: `${_ctx.icon(_ctx.column)}`,
          text: _ctx.feedbacks[_ctx.column],
          density: "compact"
        }, null, 8, ["color", "icon", "text"])), [
          [_vShow, _ctx.column !== null]
        ])
      : _createCommentVNode("", true)
  ]))
}